export const forums = {
  forumsSearchInputPlaceholder: 'Szukaj',
  forumsFollowDiscussionButtonTitle: 'Obserwuj',
  forumsFollowingDiscussButtonTitle: 'Obserwowane',
  forumDiscussionInfoNoReplyText: 'Brak odpowiedzi',
  forumsDiscussionDetailsStartButtonTitle: 'Rozpocznij dyskusję',
  forumDetailsCreatedByText: 'przez',
  forumsDiscussionDetailsUsersCurtainCopyOptionTitle: 'Skopiuj link',
  forumsDiscussionDetailsUsersCurtainFlagOptionTitle: 'Zgłoś treść',
  forumsReportedCurtainContent: 'Treść zgłoszona',
  forumsDiscussionDetailsUserCurtainCopiedAlertText: 'Link skopiowany!',
  forumsDiscussionDetailsOwnersCurtainPinOptionTitle: 'Przypnij dyskusję',
  forumsDiscussionDetailsOwnersCurtainUnpinOptionTitle: 'Odepnij dyskusję',
  forumsDiscussionDetailsOwnersCurtainEditOptionTitle: 'Edytuj dyskusję',
  forumsDiscussionDetailsOwnersCurtainDeleteOptionTitle: 'Usuń dyskusję',
  forumsDiscussionDetailspPopupDeleteTitle: 'Usuń',
  forumsDiscussionDetailspPopupDeleteText: 'Czy na pewno usunąć tę dyskusję?',
  forumsDiscussionDetailspPopupCancelButtonTitle: 'Anuluj',
  forumsDiscussionDetailspPopupConfirmButtonTitle: 'Potwierdź',
  forumsDiscussionDetailsDeleledAlertText: 'Dyskusja usunięta!',
  forumsNewDiscussionTitle: 'Nowa dyskusja',
  forumsNewDiscussionTitlePlaceholder: 'Tytuł...',
  forumsNewDiscussionBodyPlaceholderText: 'Wprowadź tekst tutaj...',
  forumsNewDiscussionPublishButtonTitle: 'Opublikuj',
  forumsNewDiscussionLocationCurtainTitle: 'Lokalizacja',
  forumsNewDiscussionLocationCurtainInputPlaceholder: 'Nazwa lokalizacji',
  forumsNewDiscussionEditLocationCurtainText: 'Edytuj lokalizację',
  forumsNewDiscussionDeleteLocationCurtainText: 'Usuń lokalizację',
  forumsNewDiscussionCreatePollTitle: 'Utwórz ankietę',
  forumsNewDiscussionTitleInputPlaceholder: 'Tytuł',
  forumsNewDiscussionOptionInputPlaceholder: 'Opcja',
  forumsNewDiscussionAddButtonTitle: 'Dodaj opcję',
  forumsNewDiscussionCreateButtonTitle: 'Utwórz',
  forumsNewDiscussionPollTitleBlankAlertText: 'Tytuł nie może być pusty!',
  forumsNewDiscussionPollOptionBlankAlertText: 'Opcja nie może być pusta!',
  forumsNewDiscussionPollLongTitleAlertText: 'Tytuł może zawierać maksymalnie 140 znaków',
  forumsNewDiscussionPollLongOptionAlertText: 'Opcja może zawierać maksymalnie 25 znaków',
  forumsNewDiscussionEditPollIconText: 'Edytuj ankietę',
  forumsNewDiscussionRemovePollIconText: 'Usuń ankietę',
  forumsDiscardDraftPopupTitle: 'Wyrzuć',
  forumsDiscardDraftPopupText: 'Czy na pewno wyrzucić tę wersję roboczą?',
  forumsDiscardDraftPopupCancelButtonTitle: 'Anuluj',
  forumsDiscardDraftPopupConfirmButtonTitle: 'Potwierdź',
  forumsDiscussionDetailsPostBodyReplyIconTitle: 'Odpowiedz',
  forumsDiscussionDetailsNoCommentsText: 'Brak komentarzy\nMożesz być pierwszy',
  forumsDiscussionDetailsReplyInputPlaceholder: 'Odpowiedz',
  forumsDiscussionDetailsPostShareCurtainOptionTitle: 'Skopiuj link',
  forumsDiscussionDetailsPostShareCopiedAlertText: 'Link skopiowany!',
  forumsDiscussionDetailsPostUsersCurtainFlagOptionTitle: 'Zgłoś treść',
  forumsDiscussionDetailsPostCurtainReportedText: 'Treść zgłoszona',
  forumsDiscussionDetailsCommentReplyIconTitle: 'Odpowiedz',
  forumsEditDiscussionTitle: 'Edytuj dyskusję',
  forumsEditDiscussionSaveButtonTitle: 'Zapisz',
  forumsEditedDiscussionSavedAlertText: 'Dyskusja zapisana!',
  forumsDiscussionDetailsOwnersCommentCurtainEditOptionTitle: 'Edytuj odpowiedź',
  forumsDiscussionDetailsOwnersCommentCurtainDeleteOptionTitle: 'Usuń odpowiedź',
  forumsDiscussionDetailsEditedCommSavedAlertText: 'Komentarz zapisany!',
  forumsDiscussionDetailsEditedCommDeletedAlertText: 'Komentarz usunięty!',
  forumsAlertSomethinWrong: 'Coś poszło nie tak!',
  forumsMaxMbSize: 'Możesz przesłać maksymalnie {size} MB naraz',
  forumsMaxAttachments: 'Przekroczono maksymalną liczbę załączników. Maksymalna liczba załączników to {max}',
  forumsDiscussionDetailsDeleteCommentPopupTitle: 'Usuń',
  forumsDiscussionDetailsDeleteCommentPopupText: 'Czy na pewno usunąć ten komentarz?',
  forumsDiscussionDetailsDeleteCommentPopupCancelButtonTitle: 'Anuluj',
  forumsDiscussionDetailsDeleteCommentPopupConfirmlButtonTitle: 'Potwierdź',
  forumsDiscussionDetailsUsersCommentCurtainFlagOptionTitle: 'Zgłoś treść',
  forumsDiscussionDetailsCommentReportedCurtainText: 'Treść zgłoszona',
  forumDiscussionInfoLastReplyText: 'Ostatnia odpowiedź',
  forumsDiscussionAt: 'o',
  forumsDiscussionDetailsFlagCurtainTitle: 'Zgłoś treść',
  forumsDiscussionDetailsFlaggedReportedCurtainContent: 'Treść zgłoszona',
  forumsPollInfoVotesText: 'głosów',
  forumsPollInfoEditVoteText: 'Edytuj głos',
  forumsPollFinishPollText: 'Zakończ ankietę',
  forumsPollFinishedPollText: 'Zakończono',
  forumsPollInProgresslText: 'W trakcie',
  forumsPollCurtainTitle: 'Zakończ ankietę',
  forumsPollCurtainText: 'Użytkownicy nie będą mogli głosować po zakończeniu ankiety.',
  forumsFinishPollCurtainCancelButtonTitle: 'Anuluj',
  forumsFinishPollCurtainConfirmlButtonTitle: 'Potwierdź',
  forumsPollInfoPollVotesCurtainTitle: 'Głosy w ankiecie'
}
